import { useRecordsFieldOptionsConfig } from "../../../../../RecordsFieldOptionsConfig/context.js";
import { toOptionsWithExisting } from "../../../../../RecordsFieldOptionsConfig/utils.js";
/* empty css                 */
import { EditableRecordField } from "../../../EditableRecordField/index.js";
import "react";
import { Constants, Label, useContainerDimensionsContext } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/Records/shared/RecordModal/components/InfoTab/ItemRecordFields.tsx
function ItemRecordFields({ canEdit, onFieldChange, record }) {
	const { viewport: { width: mainWidth } } = useContainerDimensionsContext();
	const config = useRecordsFieldOptionsConfig();
	let layout = "Xxl";
	if (mainWidth < Constants.Breakpoint.Sm.width) layout = "Sm";
	else if (mainWidth < Constants.Breakpoint.Xl.width) layout = "Xl";
	return /* @__PURE__ */ jsxs("div", {
		className: "grid grid-cols-6",
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Name"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "name",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.name
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Brand"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "brand",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.brand
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Style"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "style",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.style
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Color"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "color",
					fieldType: "select",
					options: toOptionsWithExisting(config?.item.color, record.fields.color),
					onComplete: onFieldChange,
					value: record.fields.color
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Size"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "size",
					fieldType: "text",
					onComplete: onFieldChange,
					value: record.fields.size
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: classnames({
					"col-span-2": layout === "Xxl",
					"col-span-3": layout === "Xl",
					"col-span-6": layout === "Sm"
				}),
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Status"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "status",
					fieldType: "select",
					options: toOptionsWithExisting(config?.item.status, record.fields.status),
					onComplete: onFieldChange,
					value: record.fields.status
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "col-span-6",
				children: [/* @__PURE__ */ jsx(Label, {
					block: true,
					className: "label",
					children: "Additional Info"
				}), /* @__PURE__ */ jsx(EditableRecordField, {
					canEdit,
					fieldName: "additional",
					fieldType: "textarea",
					onComplete: onFieldChange,
					value: record.fields.additional
				})]
			})
		]
	});
}
//#endregion
export { ItemRecordFields };

//# sourceMappingURL=ItemRecordFields.js.map